import { render, staticRenderFns } from "./VersionDescription.vue?vue&type=template&id=91979a24&scoped=true&"
import script from "./VersionDescription.vue?vue&type=script&lang=js&"
export * from "./VersionDescription.vue?vue&type=script&lang=js&"
import style0 from "./VersionDescription.vue?vue&type=style&index=0&id=91979a24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91979a24",
  null
  
)

export default component.exports